export default __webpack_public_path__ + "static/background-footer-9cec5ba6e2b32a7723fee18952aa5b90.png";